import React, { useState, useEffect } from 'react';
import { useNotifications } from '@/hooks/useNotifications';
import { X, TriangleAlert, RotateCcwIcon } from 'lucide-react';

const CategoryChangeModal = ({ tramite, categories, onConfirm, onClose }) => {
    const { success, error } = useNotifications();
    const [selectedCategoryId, setSelectedCategoryId] = useState('');
  
    const handleSubmit = (e) => {
      e.preventDefault();
      if (!selectedCategoryId) {
        success('Selecciona una categoría de destino');
        return;
      }
      tramite.category_id = selectedCategoryId;
      onConfirm(tramite);
    };
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1200]">
        <div className="bg-white rounded-lg max-w-md w-full mx-4">
          <div className="p-6 border-b border-gray-200">
            <div className="flex items-center justify-between">
              <h3 className="text-xl font-bold text-gray-900">
                Cambiar Categoría
              </h3>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-600 text-2xl"
              >
                <X />
              </button>
            </div>
          </div>
  
          <form onSubmit={handleSubmit} className="p-6">
            <div className="mb-6">
              <h4 className="font-medium text-gray-900 mb-2">Trámite:</h4>
              <p className="text-gray-600">{tramite.name}</p>
              <p className="text-sm text-gray-500">
                Categoría actual: {categories.find(c => c._id === tramite.category_id)?.name || 'Sin categoría'}
              </p>
            </div>
  
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-3">
                Nueva Categoría *
              </label>
              <select
                value={selectedCategoryId}
                onChange={(e) => setSelectedCategoryId(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              >
                <option value="">Selecciona nueva categoría...</option>
                {categories
                  .filter(cat => cat._id !== tramite.category_id)
                  .map((category) => (
                    <option key={category._id} value={category._id}>
                      {category.icon} {category.name}
                    </option>
                  ))}
              </select>
            </div>
  
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <div className="flex items-start">
                <span className="text-yellow-600 text-xl mr-3"><TriangleAlert /></span>
                <div className="text-sm text-yellow-800">
                  <p className="font-medium mb-1">Importante:</p>
                  <p>El trámite se moverá al final de la nueva categoría. Solo se puede cambiar si no hay solicitudes activas.</p>
                </div>
              </div>
            </div>
  
            <div className="flex justify-end space-x-3">
              <button
                type="button"
                onClick={onClose}
                className="px-6 py-3 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="px-6 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors flex row items-center gap-2"
              >
                <RotateCcwIcon />Cambiar Categoría
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };

export default  CategoryChangeModal;